import { css } from 'styled-components';
import token from 'styled-token';

/** @class PhotoCarouselSlideMixin */
/** @method */
export var PhotoCarouselSlideMixin = function PhotoCarouselSlideMixin(props) {
  var shouldAnimateTranslations = props.shouldAnimateTranslations,
    slidePosition = props.slidePosition;
  return token({
    animationDuration: 'PhotoCarousel.animations.defaultDuration',
    animationFunction: 'PhotoCarousel.animations.defaultTimingFunction',
    translateX: "PhotoCarousel.slide.horizontalTranslations." + slidePosition,
    zIndex: "PhotoCarousel.slide.zIndices." + slidePosition
  }, function (_ref) {
    var animationDuration = _ref.animationDuration,
      animationFunction = _ref.animationFunction,
      translateX = _ref.translateX,
      zIndex = _ref.zIndex;
    return css(["transition:transform ", "s ", ";transform:translateX(", "%);z-index:", ";position:absolute;left:0;top:0;right:0;bottom:0;@media (prefers-reduced-motion:reduce){&{transition:none;}}"], shouldAnimateTranslations ? animationDuration : '0', animationFunction, translateX, zIndex);
  })(props);
};